// What a webhook can be told about, said the way a person would say it.
//
// The server's event names (`work_object_archived`, `scope_access_updated`) are
// the contract and never change. Nobody should have to learn them to switch a
// notification on, so the picker is grouped by what part of the product the
// event belongs to and each one is named in words.
export type WebhookEventGroup = { events: string[]; key: string };

export const webhookEventGroups: WebhookEventGroup[] = [
  {
    key: "work",
    events: ["work_object_created", "status_changed", "field_value_changed", "work_object_archived", "work_object_restored"],
  },
  {
    key: "sprints",
    events: ["sprint_started", "sprint_closed", "sprint_scope_added", "sprint_scope_removed", "sprint_start_reverted"],
  },
  {
    key: "fields",
    events: ["field_definition_created", "field_definition_renamed", "field_definition_configured", "field_definition_archived"],
  },
  {
    key: "access",
    events: [
      "invitation_created",
      "invitation_accepted",
      "invitation_revoked",
      "member_role_updated",
      "member_removed",
      "team_created",
      "team_updated",
      "team_archived",
      "scope_access_updated",
    ],
  },
];

export const allWebhookEvents = webhookEventGroups.flatMap((group) => group.events);
